import { generateColumn, DRIVER_SECTION_UPDATE } from "../../supplementary_components/itemEditMethods";
import { DriverStatusFormatter } from './driverDataDelegate';
import { API_ROOT } from "../../supplementary_components/requests";
import { trackingColumns, createTrackingSession, applyTrackingSessionAfterSave } from "../../supplementary_components/trackingIdLookup";
import { driverPaymentTypeFormatter, driverTypeFormatter } from "./driverAddConf";
import { priceOnFinish } from "../../supplementary_components/priceInputDelegate";
import { InstallmentBalance } from "../../general_components/content_management/item_page/driver_page_components/installmentBalanceSection";
import { parseArrayOfStrings } from "../../general_components/content_management/task_list/taskListElements/diagramView";
import { RecurringPayments } from "../../general_components/content_management/item_page/driver_page_components/recurringPaymentsSection";
import { PayoutAdjustments, addEditAdjustment } from "../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection";
import { DriverFilesListing } from "../../general_components/content_management/item_page/driver_page_components/driverFilesListing";
import { generateShortId } from "../../supplementary_components/supplementaryMethods";
import { LatestActivitiesSection } from "../../general_components/content_management/item_page/latestActivitiesSection";
import { generateRandomString } from "../../supplementary_components/supplementaryMethods";
// pending,
//     active,
//     inactive,
//     atHome

export class DRIVER_PAGE_OBJECT {
    OverviewSectionColumns = (trackingSession) => {
        return [
            generateColumn(this.data, true, 'Driver Status', 'driverStatus', {
                type: "select",
                dataset: ["Pending", "Active", "Inactive", "At Home"],
                customDisplayFormat : DriverStatusFormatter,
                processBeforeSending : DriverStatusFormatter,
                customDefaultInputValue : DriverStatusFormatter(this.data['driverStatus'])
            }),
            ...trackingColumns(this, 'drivers', trackingSession),
        ]
    }
    Details = () => {
        return [
            
            generateColumn(this.data, false, "First Name", 'firstName'),
            generateColumn(this.data, false, "Middle Name", 'middleName'),
            generateColumn(this.data, false, "Last Name", 'lastName'),
            generateColumn(this.data, false, 'Driver Type', 'driverType', {
                customDisplayFormat : driverTypeFormatter,
                customDefaultInputValue: driverTypeFormatter(this.data['driverType'])
            }),
            generateColumn(this.data, false, 'Payment Type', 'paymentType', {
                customDisplayFormat : driverPaymentTypeFormatter,
                customDisabledVals : this.data['driverType'] !== "Company" ? ["Per Mile", "Salary"] : null,
            }),
            this.data.paymentType !== "None" ?
            generateColumn(this.data, false, 'DBA Company Name', [['dbaInfo', 'dbaCompanyName']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                autoComplete : 'off',
                subMenu: true,
                parentFieldName : 'paymentType',
                subMenuColumnName : 'dbaCompanyName'
            }):null,
            this.data.paymentType !== "None" ?generateColumn(this.data, false, 'DBA Tax-ID', [['dbaInfo', 'dbaTaxId']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                autoComplete : 'off',
                subMenu: true,
                parentFieldName : 'paymentType',
                subMenuColumnName : 'dbaTaxId'
            }):null,
            generateColumn(this.data, false, "Per Mile Rate", 'perMileRate', {
                hiddenInInfoCard : this.data.paymentType !== 'PerMile',
                customDisplayMode : this.data.paymentType !== 'PerMile' ? "none" :  null,
                customDisplayFormat : (val)=>{return priceOnFinish(`${val.toFixed(2)}`)},
                customDefaultInputValue : `$${this.data.perMileRate.toFixed(2)}`,
            }),
            generateColumn(this.data, false, "Salary", 'salaryPerWeek', {
                hiddenInInfoCard : this.data.paymentType !== "Salary",
                customDisplayMode : this.data.paymentType !== 'Salary' ? "none" :  null,
                customDisplayFormat : (val)=>{return priceOnFinish(`${val.toFixed(2)}`)},
                customDefaultInputValue : priceOnFinish(`${this.data.salaryPerWeek.toFixed(2)}`),
            }),
            generateColumn(this.data, false, "Gross Percentage", 'percentageFromGross', {
                hiddenInInfoCard : this.data.paymentType !== "Percentage",
                customDisplayMode : this.data.paymentType !== 'Percentage' ? "none" :  null,
                customDisplayFormat : (val)=>{return `${val * 100}%`},
                customDefaultInputValue : `${this.data.percentageFromGross * 100}%`,
            }),
            generateColumn(this.data, false, "CDL Number", 'licenseNumber'),
            generateColumn(this.data, false, "Phone Number", 'phoneNumber'),
            generateColumn(this.data, false, "Email Address", 'emailAddress'),
            generateColumn(this.data, false, "Address Line1", 'addressLine1'),
            generateColumn(this.data, false, "Address Line2", 'addressLine2'),
            generateColumn(this.data, false, "City", 'city'),
            generateColumn(this.data, false, "State", 'state'),
            generateColumn(this.data, false, "Postal Code", 'postalCode')
            
        ]
    }
    constructor(){
        this.getLink = API_ROOT+'drivers/page/';
        this.columnProportions = "22rem 1fr 0.7fr";
    }
    setData(data){
        if(data.trackingProviderOptions === undefined && this.data?.id === data.id){
            data.trackingProviderOptions = this.data.trackingProviderOptions;
        }
        this.data = data;
        this.id = data['id'];
        this.firstName = data['firstName'];
        this.middleName = data['middleName'];
        this.lastName = data['lastName'];
        this.driverStatus = data['driverStatus'];
        this.driverType = data['driverType'];
        this.notes = data['notes'];
        this.currentTruckNumber = data['currentTruckNumber']?data['currentTruckNumber']:'';
        this.installmentBalance = this.data["installmentBalance"] ? parseArrayOfStrings(this.data["installmentBalance"]) : null;
        this.recurringPayments = this.data["recurringPayments"] ? parseArrayOfStrings(this.data["recurringPayments"]) : null;
        this.header = {
            title : `${this.firstName} ${this.lastName}`,
            suplementaryInfo:this.currentTruckNumber
        };
        this.infoSections = [
            {
                title: 'Overview',
                editAccessLevel: { key: 'DRIVERS', level: 'VIEW' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const trackingSession = createTrackingSession();
                        DRIVER_SECTION_UPDATE((saved)=>{
                            setDataMethod(saved);
                            applyTrackingSessionAfterSave(trackingSession, saved, 'drivers');
                        }, this.data.id, ()=>this.OverviewSectionColumns(trackingSession));
                    }
                },
                columns : this.OverviewSectionColumns()
            },
            {
                title: 'Driver Details',
                editAccessLevel: { key: 'DRIVERS', level: 'MANAGE' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        DRIVER_SECTION_UPDATE(setDataMethod, this.data.id, this.Details);
                    }
                },
                columns : this.Details()
            }
        ];
        this.overviewSection =  [
            this.data["paymentType"] !== "None" ?{
                title : `Installment Balance`,
                editAccessLevel: { key: 'STATEMENTS', level: 'MANAGE' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            const columns = [
                                generateColumn(this.data, true, 'Payments', 'installmentBalance', {parsedData: this.installmentBalance, type: 'driverWeeklyDeductionsEditor', structureData : {
                                    labels:["Title", "Weekly Rate", "Paid Amount", "Total Amount"], 
                                    moneyField: [false, false, true, true, true],
                                    template : {hiddenFieldId: generateShortId(), title: "", weeklyRate: "", paidAmount: 0, totalAmount:""}
                                }, gridTemplateColumns : "35% 1fr 1fr 1fr"}),
                            ]
                            return columns;
                        }
                        
                        DRIVER_SECTION_UPDATE(setDataMethod, this.data.id, columns, (oldVal, newVal, key)=>{
                            if(oldVal === null && key){
                                oldVal = this.data[key]
                            }
                            if(oldVal){
                                for(let i = 0; i < oldVal.length; i++){
                                    if(!newVal || i >= newVal.length)continue; 
                                    const parsedNewVal = typeof(newVal[i]) === "string" ?  JSON.parse(newVal[i]) : newVal[i];
                                    const parsedOriginalVal = JSON.parse(oldVal[i])
                                    if(parsedNewVal.hiddenFieldId === parsedOriginalVal.hiddenFieldId){
                                        parsedNewVal["paidByInvoices"] = parsedOriginalVal["paidByInvoices"];
                                        newVal[i] = JSON.stringify(parsedNewVal);
                                    }
                                }
                            }
                            
                            return newVal;
                            
                        })
                    }
                },
                content: ()=>{
                    return <InstallmentBalance data={this.installmentBalance} />
                }
            } : null,
            this.data["paymentType"] !== "None" ? {
                title : `Recurring`,
                editAccessLevel: { key: 'STATEMENTS', level: 'MANAGE' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            const columns = [
                                generateColumn(this.data, true, 'Payments', 'recurringPayments', {parsedData: this.recurringPayments, type: 'driverWeeklyDeductionsEditor', structureData : {
                                    labels:["Type", "Title", "Rate", "Daily", "Per mi"], 
                                    moneyField: [false, false, false, true, false, false],
                                    checkboxField: [false, false, false, false, true, true],
                                    selectField: [false, true, false, false, false, false],
                                    exclusiveCheckboxGroups: [["allowDailyCalculation", "perMile"]],
                                    selectOptions: { type: [{value: "charge", label: "Charge"}, {value: "bonus", label: "Bonus"}] },
                                    serializeAsObjects: true,
                                    template : {id: generateShortId(), type: "charge", title: "", weeklyRate: "", allowDailyCalculation: false, perMile: false}
                                }, gridTemplateColumns : "6.5rem minmax(0, 1fr) 8rem 3.4rem 4.2rem"}),
                            ]
                            return columns;
                        }
                        DRIVER_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                        // LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                    }
                },
                content: ()=>{
                    return <RecurringPayments data={this.recurringPayments} />
                }
            }  : null ,
            this.data["paymentType"] !== "None" ? 
            {
                title : `Payout Adjustments`,
                editAccessLevel: true,
                editButton : {
                    text: 'Add',
                    action: (setDataMethod)=>{
                        addEditAdjustment(this.data, setDataMethod, null, this.data.company.id, this.data.id)
                    }
                },
                content: ()=>{
                    return <PayoutAdjustments companyId={this.data.company.id} driverId={this.data.id} newlyAddedAdjustment={this.data.newAdjustment} />
                }
            } :null,
            {
                title : `Files`,
                content: (setDataMethod)=>{
                    return <DriverFilesListing
                        files={this.data["files"]}
                        driverId={this.data['id']}
                        setDataMethod={setDataMethod}
                    />
                },
                headerLine :true
            },
            // {
            //     title : `This week's performance`,
            //     type: 'content',
            // },
            // {
            //     title : `Previous Week`,
            //     type: 'content',
            // },
            {
                title : `Latest Activities`,
                content: ()=>{
                    return <LatestActivitiesSection type="DRIVER" objectId={this.id} refreshKey={generateRandomString(4)}  />
                },
                headerLine :true
            }
        ]
        this.notesSection = {

        }
    }
}
